export const zindex = {
  portal: 50000,
  toast: 100000000,
  modal: 30000,
  popover: 20000,
  navigation: 1999,
};
